module.exports = __webpack_public_path__ + "img/Weapon_170.badc016a.png";